(() => {
  const STORAGE_KEY = 'bgroudWishlist';

  function readWishlist() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // If storage is unavailable, the current page still updates visually.
    }
    sync(items);
    document.dispatchEvent(new CustomEvent('bgroud:wishlist-change', { detail: { items } }));
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.productId || ''),
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || ''
    };
  }

  function setHeartState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    const title = button.dataset.productTitle || 'product';
    button.setAttribute(
      'aria-label',
      active ? 'Remove ' + title + ' from favorites' : 'Add ' + title + ' to favorites'
    );
  }

  function syncHearts(items) {
    const ids = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-bgroud-wishlist]').forEach((button) => {
      setHeartState(button, ids.has(String(button.dataset.productId || '')));
    });
  }

  function syncCount(items) {
    const count = items.length;
    document.querySelectorAll('[data-bgroud-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  function createFavoriteCard(item) {
    const article = document.createElement('article');
    article.className = 'bgroud-favorite-card';
    article.dataset.productId = String(item.id || '');

    const media = document.createElement('a');
    media.className = 'bgroud-favorite-card__media';
    media.href = item.url || '/collections/all';

    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title || 'Product';
      image.loading = 'lazy';
      media.appendChild(image);
    }

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'bgroud-favorite-card__remove';
    remove.dataset.removeFavorite = '';
    remove.setAttribute('aria-label', 'Remove ' + (item.title || 'product') + ' from favorites');
    remove.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.2 4.7 13.3C1.9 10.7 2.8 6.1 6.9 5.2c2.1-.5 4.1.5 5.1 2.2 1.1-1.7 3.1-2.7 5.2-2.2 4 .9 4.9 5.5 2.1 8.1L12 20.2Z"/></svg>';

    const info = document.createElement('div');
    info.className = 'bgroud-favorite-card__info';

    const title = document.createElement('a');
    title.className = 'bgroud-favorite-card__title';
    title.href = item.url || '/collections/all';
    title.textContent = item.title || 'Product';

    const price = document.createElement('div');
    price.className = 'bgroud-favorite-card__price';
    price.textContent = item.price || '';

    const view = document.createElement('a');
    view.className = 'bgroud-favorite-card__view';
    view.href = item.url || '/collections/all';
    view.textContent = 'View product →';

    info.append(title, price, view);
    article.append(media, remove, info);
    return article;
  }

  function renderFavorites(items) {
    const grid = document.querySelector('[data-bgroud-favorites-grid]');
    const empty = document.querySelector('[data-bgroud-favorites-empty]');
    const clearButton = document.querySelector('[data-bgroud-favorites-clear]');
    if (!grid || !empty || !clearButton) return;

    grid.replaceChildren();
    grid.hidden = items.length === 0;
    empty.hidden = items.length !== 0;
    clearButton.hidden = items.length === 0;

    items.forEach((item) => grid.appendChild(createFavoriteCard(item)));
  }

  function sync(items = readWishlist()) {
    syncHearts(items);
    syncCount(items);
    renderFavorites(items);
  }

  function toggleWishlist(button) {
    const product = productFromButton(button);
    if (!product.id) return;

    const items = readWishlist();
    const index = items.findIndex((item) => String(item.id) === product.id);

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push(product);
    }

    writeWishlist(items);
  }

  document.addEventListener('click', (event) => {
    const heart = event.target.closest('[data-bgroud-wishlist]');
    if (heart) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(heart);
      return;
    }

    const remove = event.target.closest('[data-remove-favorite]');
    if (remove) {
      event.preventDefault();
      const card = remove.closest('[data-product-id]');
      if (!card) return;
      const id = String(card.dataset.productId || '');
      writeWishlist(readWishlist().filter((item) => String(item.id) !== id));
      return;
    }

    const clear = event.target.closest('[data-bgroud-favorites-clear]');
    if (clear) {
      event.preventDefault();
      writeWishlist([]);
    }
  });

  document.addEventListener('shopify:section:load', () => sync());
  document.addEventListener('bgroud:wishlist-refresh', () => sync());

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) sync();
  });

  window.addEventListener('pageshow', () => sync());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync(), { once: true });
  } else {
    sync();
  }
})();
